import {
  Button, Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import {useRouter} from "next/router";

export const VerificationSuccessModal = ({isSuccessOpen, onSuccessClose}) => {
  const router = useRouter();

  return (
    <Modal isOpen={isSuccessOpen} onClose={onSuccessClose} isCentered>
      <ModalOverlay/>
      <ModalContent>
        <ModalHeader>Your payment has been received</ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
          <p>Your payment has been received</p>
          <p>
            Our team will start verifying your professional accreditation,
            which usually happens in the same working day. We will contact you
            via email if we need more information from you.
          </p>
        </ModalBody>

        <ModalFooter>
          <Button
            mr={3}
            onClick={() => {
              onSuccessClose();
              router.push({
                pathname: `${window.location.href.split('?')[0]}`,
                query: {
                  tab: 'verification'
                },
              }, undefined, {shallow: true});
            }}
          >
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
};
